import { useRef, useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { AgGridReact } from 'ag-grid-react';
import { colTypesWidths } from '~/components/ui/tables/ag/columnTypes';
import { createAgTheme } from '~/components/ui/tables/ag/agTheme';
import { siteThemeMode } from '~/atoms/userPreferencesAtoms';
import { colDefsFundsTable, Fund } from './colDefsFundsTable';
import { colDefsFoldersTable } from './colDefsFoldersTable';

export type FundsTableProps = {
  loading?: boolean;
  rowData: Fund[];
};

export const FundsTable = ({ loading, rowData }: FundsTableProps) => {
  const gridRef = useRef<AgGridReact<Fund>>(null);
  const themeMode = useAtomValue(siteThemeMode);
  const gridTheme = useMemo(() => createAgTheme(themeMode), [themeMode]);
  const detailCellRendererParams = {
    detailGridOptions: {
      autoSizeStrategy: {
        type: 'fitGridWidth',
        defaultMinWidth: 100,
      },
      overlayNoRowsTemplate: 'No folders found.',
      columnDefs: colDefsFoldersTable,
    },
    getDetailRowData: (params) => {
      params.successCallback(params.data.googleWatchChannels);
    },
  };
  return (
    <div style={{ height: '100%' }}>
      <AgGridReact
        masterDetail={true}
        detailCellRendererParams={detailCellRendererParams}
        rowData={rowData}
        ref={gridRef}
        loading={loading}
        columnDefs={colDefsFundsTable}
        columnTypes={colTypesWidths}
        tooltipShowDelay={0}
        theme={gridTheme}
        suppressContextMenu
        colResizeDefault="shift"
        suppressCellFocus
        overlayNoRowsTemplate={
          '<span class="custom-no-rows">No data available! Please check back later.</span>'
        }
        onColumnResized={(params) => {
          if (params.finished) params.api.sizeColumnsToFit();
        }}
        autoSizeStrategy={{
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        }}
      />
    </div>
  );
};
